import React, { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom/es";
import { NotFoundPage } from "signoxe/components";
import {
  AQIAssetEditPage,
  // AssetPage,
  AssetsPage,
  AssetCheckerPage,
  CalendarAssetEditPage,
  ChangePasswordPage,
  ChangeEmailPage,
  DataAssetEditPage,
  DeviceSchedulePage,
  DeviceScreenShotsPage,
  DevicesPage,
  FidsAssetEditPage,
  NotificationsListPage,
  PlaylistPage,
  PlaylistsPage,
  ChannelPage,
  ChannelsPage,
  PreviewPage,
  ChannelPreviewPage,
  TickerSeriesListPage,
  TickerSeriesPage,
  UserProfilePage,
  URLAssetEditPage,
  WebAssetEditPage,
  AQIAirvedaEditPage,
  ClientUserListPage,
  ClientUserCreatePage,
  HtmlEditorPage,
  ReportsPage,
  HostAppsPage,
  PairDevice,
  ReportDownloadLinkPage,

} from "signoxe/containers";

import { AssetPage } from "../../containers";

import { AssetWrapper } from "signoxe/components";

import PrivateRoute from "../PrivateRoute";

let reportURL = "/report";


/*
  If user is only offline -> Have own switch and return it with only a single route
*/

const AppRoutes = () => (
  <Switch>
    <Redirect exact from="/login" to={reportURL} />
    <Redirect exact from="/" to={reportURL} />
    <Redirect exact from="/login-for/:code" to={reportURL} />


    <Route exact path="/assets/new/fids" component={FidsAssetEditPage} />
    <Route path="/assets/edit/fids/:id" component={FidsAssetEditPage} />
    <PrivateRoute
      exact
      path="/assets/edit/web/:id"
      component={WebAssetEditPage}
    />

    <PrivateRoute exact path="/report" component={ReportsPage} />
    <PrivateRoute exact path="/assets/new/web" component={WebAssetEditPage} />
    <PrivateRoute
      exact
      path="/assets/edit/url/:id"
      component={URLAssetEditPage}
    />
    <PrivateRoute
      exact
      path="/assets/edit/aqi/:id"
      component={AQIAssetEditPage}
    />
    <PrivateRoute exact path="/assets/new/url" component={URLAssetEditPage} />
    <PrivateRoute exact path="/assets/new/data" component={DataAssetEditPage} />
    <PrivateRoute exact path="/assets/new/aqi" component={AQIAssetEditPage} />
    <PrivateRoute
      exact
      path="/assets/new/aqi_airveda"
      component={AQIAirvedaEditPage}
    />
    <PrivateRoute
      path="/assets/edit/cal/:id"
      component={CalendarAssetEditPage}
    />
    <PrivateRoute
      exact
      path="/assets/new/cal"
      component={CalendarAssetEditPage}
    />
    <PrivateRoute path="/asset/:id" component={AssetPage} />

    <PrivateRoute path="/assets" component={AssetWrapper} />

    <PrivateRoute path="/checker" component={AssetCheckerPage} />

    <PrivateRoute path="/template-edit" component={HtmlEditorPage} />

    <PrivateRoute path="/devices/pairing" component={PairDevice} />
    <PrivateRoute path="/devices/:id" component={DeviceScreenShotsPage} />

    <PrivateRoute exact path="/device-groups" component={DevicesPage} />
    <PrivateRoute
      path="/device-groups/:id/schedule"
      component={DeviceSchedulePage}
    />
    <PrivateRoute exact path="/playlists" component={PlaylistsPage} />

    <PrivateRoute path="/playlists/:id" component={PlaylistPage} />

    <PrivateRoute exact path="/channels" component={ChannelsPage} />

    <PrivateRoute exact path="/channels/:id" component={ChannelPage} />

    <PrivateRoute exact path="/tickers" component={TickerSeriesListPage} />
    <PrivateRoute path="/tickers/:id" component={TickerSeriesPage} />

    <PrivateRoute
      path="/preview/:playlistId/:tickerId?"
      component={PreviewPage}
    />
    <PrivateRoute
      path="/channel-preview/:channelId"
      component={ChannelPreviewPage}
    />

    <PrivateRoute exact path="/profile" component={UserProfilePage} />
    <PrivateRoute
      exact
      path="/profile/change-password"
      component={ChangePasswordPage}
    />

    <PrivateRoute
      exact
      path="/profile/change-email"
      component={ChangeEmailPage}
    />

    <PrivateRoute
      exact
      path="/notifications/:notificationId?"
      component={NotificationsListPage}
    />

    <PrivateRoute exact path="/client-users" component={ClientUserListPage} />
    <PrivateRoute
      exact
      path="/client-users-create"
      component={ClientUserCreatePage}
    />
     <PrivateRoute
      exact 
      path="/device-email-reports/:slug"
      component={ReportDownloadLinkPage}
    />
    <Route component={NotFoundPage} />
  </Switch>
);

export default AppRoutes;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/AppRoutes/index.js